import { SortDescriptor } from '@progress/kendo-data-query';
import { LongRunningContextCategoryTyp } from 'src/app/samwebDescription/samweb/waitingContext/waitingContextCategory';
import { LongRunningAction } from 'src/app/store/server-communication/running-actions/types/longRunningAction.decorator';
import { GridSortSettingsRealTimeData } from 'src/generated/signalR/grid-sort-settings-real-time-data';
import { BrickDefinitionRemoteDto } from 'src/generated/swagger';

export class BrickWallChangedByServer {
   public static readonly type = '[Grid Column Sorting] Brick Wall Changed By Server';

   constructor(public bricks: BrickDefinitionRemoteDto[]) {}
}

export class GridSortSettingsUpdatedByServer {
   public static readonly type = '[Grid Column Sorting] Grid Sort Settings Updated By Server';

   constructor(public sortSettings: GridSortSettingsRealTimeData) {}
}

export class GridSortSettingsChanged {
   public static readonly type = '[Grid Column Sorting] Grid Sort Settings Changed';

   constructor(public brickInstanceId: string, public customSorting: SortDescriptor, public gridName: string = 'default') {}
}
@LongRunningAction(LongRunningContextCategoryTyp.BRICK_WALL)
export class PersistGridSortSettings {
   public static readonly type = '[Grid Column Sorting] Persist Grid Sort Settings';

   constructor(public brickInstanceId: string) {}
}
@LongRunningAction(LongRunningContextCategoryTyp.BRICK_WALL)
export class PersistAllGridSortSettings {
   public static readonly type = '[Grid Column Sorting] Persist All Grid Sort Settings';

   constructor(public brickInstanceIds: string[]) {}
}
